import React, { memo } from 'react';

import anchorme from 'anchorme';
import { ContentState, EditorState } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import HtmlParser from 'html-react-parser';
import htmlToDraft from 'html-to-draftjs';
import { Editor } from 'react-draft-wysiwyg';

import { toolbarMango } from '../../../../shared/data';
import { IQuestionAnswerAttachment } from '../../../../types/assignmentTypes';
import { extractPlainTextAndCountCharacters } from '../../utils/AssignmentHelpers';
import { useAssignmentContext } from '../../utils/AssignmentProvider';

interface Props {
  questionId: string;
  subjectiveAnswer: string;
  characterLimit?: number;
  attachments: IQuestionAnswerAttachment[];
}

// Helper function to check if HTML content is empty
const isHtmlContentEmpty = (htmlContent: string): boolean => {
  if (!htmlContent) return true;

  // Convert HTML to plaintext and check if it's empty or only whitespace
  const { plainText } = extractPlainTextAndCountCharacters(htmlContent);
  return plainText.trim().length === 0;
};

const AssignmentSubjectiveQuestion: React.FC<Props> = ({
  questionId,
  subjectiveAnswer,
  characterLimit,
  attachments,
}) => {
  const { saveQuestionAnswer, flow } = useAssignmentContext();

  const [editorState, setEditorState] = React.useState(
    EditorState.createEmpty(),
  );

  const isFirstRender = React.useRef(true);

  const onContentStateChange = (contentState: any) => {
    const content = draftToHtml(contentState);
    if (content) {
      saveQuestionAnswer(
        questionId,
        'save',
        {
          subjectiveAnswer: anchorme(content),
          attachments,
        },
        false,
      );
    }
  };

  const onEditorStateChange = (state: EditorState) => {
    setEditorState(state);
  };

  const { characterCount } =
    extractPlainTextAndCountCharacters(subjectiveAnswer);

  React.useEffect(() => {
    if (
      !subjectiveAnswer ||
      isHtmlContentEmpty(subjectiveAnswer) ||
      !isFirstRender.current
    ) {
      isFirstRender.current = false;
      return;
    }

    isFirstRender.current = false;

    const blocksFromHtml = htmlToDraft(subjectiveAnswer);
    const { contentBlocks, entityMap } = blocksFromHtml;
    const contentState = ContentState.createFromBlockArray(
      contentBlocks,
      entityMap,
    );
    const newEditorState = EditorState.createWithContent(contentState);
    setEditorState(newEditorState);
  }, [subjectiveAnswer]);

  return (
    <div style={{ marginTop: 24 }}>
      {/* <div
        style={{
          border: '1px solid #e9ecef',
          backgroundColor: '#f8f9fa',
          padding: 12,
          borderRadius: 8,
          marginTop: 24,
          flex: 1,
          cursor: 'pointer',
          transition: 'opacity 0.2s ease',
          // ...(subjectiveAnswer ? {} : { minHeight: 140 }),
        }}>
        {subjectiveAnswer ? (
          <div style={{ flex: 1 }}>{HtmlParser(subjectiveAnswer)}</div>
        ) : (
          <div>
            <div
              style={{
                fontSize: '14px',
                color: '#666',
                fontWeight: '400',
              }}>
              Write an answer
            </div>
          </div>
        )}
      </div> */}
      {subjectiveAnswer && characterLimit && flow === 'submit' ? (
        <div
          style={{
            fontSize: 12,
            color: characterCount > characterLimit ? 'red' : '#666',
            marginBottom: 8,
            textAlign: 'right',
          }}>
          {characterCount} / {characterLimit}
        </div>
      ) : null}

      {flow === 'submit' ? (
        <Editor
          editorState={editorState}
          toolbar={toolbarMango}
          stripPastedStyles
          placeholder="Write an answer"
          toolbarClassName="toolbarClassName"
          wrapperClassName="emailBodyEditorWrapper"
          editorClassName="editorClassName"
          onEditorStateChange={onEditorStateChange}
          onContentStateChange={onContentStateChange}
        />
      ) : flow === 'review' && !isHtmlContentEmpty(subjectiveAnswer) ? (
        <div
          style={{ border: '1px solid #e9ecef', padding: 12, borderRadius: 8 }}>
          {HtmlParser(subjectiveAnswer)}
        </div>
      ) : null}
    </div>
  );
};

export default memo(AssignmentSubjectiveQuestion);
